import SingleBar from './SingleBar'

export default SingleBar
